import {
  Grid,
  TextField,
  InputAdornment,
} from "@mui/material";
import { useEffect, useState } from "react";
import { ProductSupplier, setTransactionsDialog } from "../../../../../app/slices/productsSupplierSlice";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { useParams } from "react-router";
import {
  HiOutlineWallet,
  HiOutlineBanknotes,
  HiOutlineDocumentText,
} from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../../components/FormDialog";

const PayCashForm = (props) => {
  const dispatch = useDispatch();
  const { product_supplier_id } = useParams();
  const _ProductSupplierPayCash = useSelector((state) => state.productSupplier.transactions);
  const _SearchBody = useSelector((state) => state.productSupplier.transactions.searchBody);

  const { control, reset, watch, register, handleSubmit, setValue } = useForm({
    defaultValues: {},
  });

  const onSubmit = (data) => {
    dispatch(ProductSupplier.payCash({
      product_supplier_id: parseInt(product_supplier_id),
      wage_amount: data.wage_amount,
      amount: data.amount,
      note: data.note
    }, _SearchBody))
  };

  const handleDialog = () => {
    dispatch(setTransactionsDialog());
  };

  useEffect(() => {
    setValue('wage_amount', watch('amount') * watch('wage_amount_percent') / 100);
  }, [watch('amount'), watch('wage_amount_percent')])

  return (
    <FormDialog
      open={_ProductSupplierPayCash.dialog}
      onClose={handleDialog}
      icon={<HiOutlineWallet />}
      title={'تسديد مبالغ المجهز'}
      subtitle="أدخل المبلغ ونسبة الشركة لتسديد مبالغ المجهز"
      onSubmit={handleSubmit(onSubmit)}
    >
      <SectionCard icon={<HiOutlineBanknotes />} title="المبالغ">
        <Grid item xs={12}>
          <Controller
            name="amount"
            control={control}
            render={({ field: { onChange, ...renderProps } }) => {
              return (
                <NumericFormat
                  customInput={TextField}
                  label='المبلغ'
                  size="small"
                  required
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position="start">IQD</InputAdornment>,
                  }}
                  {...renderProps}
                  onValueChange={target => {
                    onChange();
                    setValue('amount', target.floatValue);
                  }}
                  isNumericString
                  thousandSeparator
                />
              );
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="wage_amount_percent"
            control={control}
            render={({ field: { onChange, ...renderProps } }) => {
              return (
                <NumericFormat
                  customInput={TextField}
                  label='نسبة الشركة'
                  size="small"
                  required
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position="start">%</InputAdornment>,
                  }}
                  {...renderProps}
                  onValueChange={target => {
                    onChange();
                    setValue('wage_amount_percent', target.floatValue);
                  }}
                  isNumericString
                  thousandSeparator
                />
              );
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="wage_amount"
            control={control}
            render={({ field: { onChange, ...renderProps } }) => {
              return (
                <NumericFormat
                  customInput={TextField}
                  label='المبلغ'
                  size="small"
                  disabled
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position="start">IQD</InputAdornment>,
                  }}
                  {...renderProps}
                  isNumericString
                  thousandSeparator
                />
              );
            }}
          />
        </Grid>
      </SectionCard>
      <SectionCard icon={<HiOutlineDocumentText />} title="الملاحظات">
        <Grid item xs={12}>
          <Controller
            name="note"
            control={control}
            render={({ field }) => (
              <TextField
                size="small"
                label="الملاحظة"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default PayCashForm;
